<template>
  <div class="post">
    <el-card class="box-card post-card">
      <div slot="header" class="clearfix" v-if="type == 'topic'">
        <el-row class="header">
          <div class="header-data hidden-sm-and-down">
            查看：<span class="text-red">--</span> 回复：<span class="text-red"
              >--</span
            >
          </div>
          <el-col
            :xs="24"
            :sm="24"
            :md="20"
            :lg="20"
            :xl="20"
            class="header-title"
          >
            --
          </el-col>
        </el-row>
      </div>

      <el-row class="info">
        <div class="info-nickname hidden-sm-and-down">
          <router-link :to="'/u/0'">
            <span class="text-wch text-bold"> -- </span>
          </router-link>
        </div>
        <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20" class="info-ext">
          <div class="info-create">
            <router-link :to="'/u/0'" class="hidden-sm-and-up text-wch">
              --
            </router-link>

            发表于：--
          </div>
          <div class="info-tool hidden-sm-and-down"></div>
        </el-col>
      </el-row>
      <el-row class="content">
        <div class="content-user hidden-sm-and-down">
          <UserAvatar :size="120" :user="null" />
          <div class="content-user-data">
            <div class="content-user-value">
              <span class="text-highlinght">{{ "-" }}</span>
            </div>
            <div class="content-user-value">
              <span class="text-highlinght">{{ "-" }}</span>
            </div>
            <div class="content-user-value">
              <span class="text-highlinght">{{ "-" }}</span>
            </div>
            <div class="content-user-value">主题</div>
            <div class="content-user-value">回复</div>
            <div class="content-user-value">积分</div>
          </div>
        </div>
        <el-col
          :xs="24"
          :sm="24"
          :md="20"
          :lg="20"
          :xl="20"
          class="content-value"
        >
          <div class="content-value-html">
            <el-skeleton :rows="6" animated />
          </div>

          <SignatureAd v-if="type == 'topic'" />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar";
import SignatureAd from "@/components/SignatureAd";
import "prismjs/themes/prism.css"; // 引入你喜欢的主题
export default {
  props: {
    values: {
      required: true,
      default: {},
    },
    type: {
      required: true,
      default: "topic",
    },
    floor: {
      required: true,
      default: 1,
    },
    currentPage: {
      required: true,
      default: 1,
    },
  },
  data() {
    return {
      list: null,
      listLoading: true,
      total: 0,
      pageSize: 10,
      // currentPage: 1,
    };
  },

  components: {
    UserAvatar,
    SignatureAd
  },
};
</script>
<style lang="less">
.post {
  background-color: #fff;

  border: 1px solid #969696;
  .el-card {
    margin: 3px;
    background-color: #ebebeb;
    .el-card__header {
      min-height: 30px;
      height: auto !important;
      padding: 0;
      .header {
        display: flex;
        border-bottom: 3px solid #969696;
        .header-data {
          width: 200px;
          border-right: 2px solid #fff;
          line-height: 30px;
          font-size: 12px;
        }
        .header-title {
          font-weight: 700;
          line-height: 30px;
          padding-left: 15px;
          text-align: left;
        }
      }
    }
    .el-card__body {
      padding: 0;
      .info {
        min-height: 38px;
        height: auto !important;
        height: 38px;
        line-height: 38px;
        display: flex;
        .info-nickname {
          width: 200px;
          border-right: 2px solid #fff;
          text-align: center;
        }
        .info-ext {
          // width: 80%;
          display: flex;
          .info-create {
            padding-left: 15px;
            width: 220px;
            text-align: left;

            //超出部分省略号

            a {
              display: inline-block;
              max-width: 80px;
              height: 14px;
              line-height: 14px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          .info-tool {
            text-align: right;
            // width: 100%;
            display: flex;
            justify-content: flex-end; /* 关键：将子元素靠右对齐 */
            flex: 1; /* 自动填充剩余空间 */
            ul {
              padding: 0;
              margin: 0;
              li {
                margin-right: 5px;
                list-style: none;
                float: right;
              }
              li.btn {
                color: #00428b;
                font-weight: 700;
                cursor: pointer;
              }
            }
            /* 楼层号样式 */
            p {
              margin: 0 0 0 10px; /* 只保留左侧间距 */
              white-space: nowrap; /* 防止楼层号换行 */
            }
            .c-more-button {
              flex-shrink: 1;
              max-width: 100%;
              white-space: nowrap !important;
            }
          }
        }
      }
      .content {
        border-top: 1px dashed #969696;
        min-height: 200px;
        height: auto !important;
        height: 200px;
        border-bottom: 2px solid #ffffff;
        display: flex;
        .content-user {
          width: 200px;
          border-right: 2px solid #fff;
          text-align: center;
          padding-top: 20px;
          .content-user-data {
            width: 120px;
            margin: 10px auto;
            .content-user-value {
              margin-top: 10px;
              width: 40px;
              float: left;
              text-align: center;
            }
          }
        }
        .content-value {
          text-align: left;
          // width: 80%;
          .content-value-html {
            margin: 20px;
            min-height: 300px;
          }
          img {
            max-width: 600px;
            display: block;
            margin-bottom: 10px;
            margin-top: 10px;
            border: 1px solid #ddd;
            -webkit-box-shadow: 0 0 30px #ccc;
            box-shadow: 0 0 30px #ccc;
          }
          .user-btn {
            margin: 20px;
            margin-top: 10px;
            padding-top: 5px;

            min-height: 20px;
            height: auto !important;
            font-size: 12px;
            margin-bottom: 20px;
          }
          .ad {
            margin: 20px;
            margin-top: 10px;
            padding-top: 5px;
            border-top: 1px solid #969696;
            min-height: 40px;
            height: auto !important;
            font-size: 12px;
            margin-bottom: 20px;
          }
          //padding: 20px;
        }
      }
    }
  }
}

.forum-card {
  //border: 1px solid #969696 !important;

  .el-card__header {
    padding: 0;

    .header {
      height: 30px;
      background-color: #1483dc;
      border-radius: 0px;
      padding: 0px;
      text-align: left;
      padding-left: 20px;
      padding-right: 20px;
    }

    .tool {
      height: 20px;
      background-color: #e1dfdf;
      color: #00428b;
      font-size: 12px;
      line-height: 20px;
      display: flex;
      padding-left: 20px;
      padding-right: 20px;
      .forum-item-ext-post-num {
        margin: 0;
      }
      .forum-item-ext-reply-num {
        margin: 0;
      }
      .forum-item-ext-reply {
        margin: 0;
      }
    }
    a {
      font-size: 14px;
      font-weight: bold;

      line-height: 30px;
      color: #ebebeb;
      display: block;
      float: left;
    }
  }

  margin-bottom: 20px;
}

.forum-item {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  border-bottom: 1px dashed #969696;
  min-height: 80px;
  display: flex;

  &:last-child {
    border-bottom: none !important;
  }
}
// .forum-item-value {
//   display: flex;
//   width: 80%;
//   .el-avatar {
//     background-color: #fff;
//     margin-top: 15px;
//   }
//   .forum-item-name {
//     margin-left: 10px;

//     display: flex;
//     flex-direction: column;
//     align-items: flex-start;
//     text-align: left;
//     .forum-item-ext-reply {
//       line-height: 1;
//     }
//   }
// }
.forum-item-ext {
  width: 300px;
  display: flex;
  //justify-content: flex-end;
  .forum-item-ext-post-num {
    text-align: left;
    width: 50px;
    margin-top: 20px;
  }
  .forum-item-ext-reply-num {
    width: 50px;
    margin-top: 20px;
    text-align: left;
  }
  .forum-item-ext-reply {
    text-align: right;
    margin-top: 20px;
    margin-left: 15px;

    .forum-item-ext-reply-time {
      margin-top: 5px;
    }
  }
}
// pre[class*="language-"] {
//   max-width: 600px;
// }
</style>
